import { HttpParams } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DashboardService, Dashboard_Counter_Props, Dashboard_News_Props } from 'src/app/services/dashboard/dashboard.service';
import { InvoicesService } from 'src/app/services/invoices/invoices.service';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { UserService } from 'src/app/services/users/user.service';
import {DomSanitizer} from '@angular/platform-browser';
import { GenericResponse } from 'src/app/entities/various';
import { FattureAttiveService } from 'src/app/services/fatture-attive/fatture-attive.service';




export interface FattureList{
  denominazione : string ,
  invoice_n : string ,
  invoice_data: string ,
  amount: string ,
  workflow_state : string ,
  error: string ,
  relateds: string[]
}




@Component({
  selector: 'app-dashboard-index',
  templateUrl: './dashboard-index.component.html',
  styleUrls: ['./dashboard-index.component.css']
})

export class DashboardIndexComponent implements OnInit {

  navigator: string = 'sidebar.dashboard';
  listBackgroudColorCard: string[] = [
    'var(--dashboard1)',
    'var(--dashboard2)',
    'var(--dashboard3)',
    'var(--dashboard4)'
  ]

  lng: string = "it";
  classColumns: string = "col-3";

  params : HttpParams;
  userInfo: UserInfo | undefined;

  scartate: boolean = false;
  bozze: boolean = false;
  inviate: boolean = false;
  ricevute: boolean = false;
  numeroScartate: number = 0;
  numeroBozze: number = 0;
  numeroInviate: number = 0;
 
  elencoClientiScartate: any[] = [];
  elencoClientiBozze: any[] = [];

  bozzeList : FattureList[]=[];
  scartateList : FattureList[]=[];
  inviateList : FattureList[]= [];
  ricevuteList : FattureList[]=[];
  refreshTime: Date | undefined;
  isLoadingUser: boolean = true;

  dashboardCounter :  Dashboard_Counter_Props[] | undefined;
  dashboardNews : Dashboard_News_Props[] | undefined;

  updateScartate: boolean = false;
  updateBozze: boolean = false;
  updateRicevute: boolean = false;

  constructor(private dashboardService : DashboardService, 
    public translate: TranslateService,
    public invoiceService: InvoicesService,
    public loginService: LoginService,
    public toastService: ToastService,
    public userService: UserService,
    public sanitizer: DomSanitizer,
    public fatturaAttivaService: FattureAttiveService) { 

      this.params = new HttpParams();
      this.params = this.params.append('endRow', 0);
      this.params = this.params.append('lastKeyVal', '');
      this.params = this.params.append('page', 1);
      this.params = this.params.append('pageDirection', 'FORWARD');
      this.params = this.params.append('pageSize', 12);
      this.params = this.params.append('pagination', true);
      this.params = this.params.append('paginationMode', 'SKIP');
      this.params = this.params.append('rows', 0);
      this.params = this.params.append('searchFilter', '{}');
      this.params = this.params.append('sortDir', 'DESC');
      this.params = this.params.append('sortKey', 'date_created');
      this.params = this.params.append('startRow', 0);
      this.params = this.params.append('totalPages', -1);
      this.params = this.params.append('totalRows', 0);
    
  }

  // Evento resize della pagina in modo da rendelo resposize
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setColumnsClass(event.target.innerWidth);
  }
  setColumnsClass(width: number){
    if(width < 900){
      this.classColumns = "col-12 cardTotalWidth";
    } else if(width < 1100){
      this.classColumns = "col-6 cardTotalWidth";
    } else if(width < 1600){
      this.classColumns = "col-4";
    } else {
      this.classColumns = "col-3";
    }
    return this.classColumns;
  }


  /**
   * Gestione cambio lingua
   */
   changeLanguage(){
     this.lng = this.lng == "it" ? "en" : "it";
     this.translate.setDefaultLang(this.lng);
   }

  async ngOnInit() {
    //console.log("dashboard");
    this.userInfo = JSON.parse(localStorage.getItem("einvuser") || "");
    //let role=this.userInfo!.role;
    
    /*this.dashboardNews = await (await this.dashboardService.getDashboardNews()).data as Dashboard_News_Props[];*/
    this.dashboardCounter = undefined;
    
  }

  async ngAfterViewInit() {

    this.dashboardCounter = (await this.dashboardService.getDashboard()).data as Dashboard_Counter_Props[];
    this.dashboardCounter?.forEach(v => {
      switch(v.title){
        case "Utenti":
          v.panel_style = "users.svg";
          break;
        case "Limite utenti":
          v.panel_style = "users.svg";
          break;
        case "Limite fatture":
          v.panel_style = "fattura_dashboard.svg";
          break;
              
      }
    
    });

    await this.initData();

  }


  async initData(){
    if(localStorage.getItem("dashboardData_"+this.userInfo!.user_id) === null){
      this.refreshTime=new Date();
      this.isLoadingUser=true;
      //this.callStack();
    }else{
      var data=localStorage.getItem("dashboardData_"+this.userInfo!.user_id);
          data=JSON.parse(data!);
      // @ts-ignore
      if(this.getPassedTime(data.refreshTime) >=10){
            //this.callStack();
      }else{
        // @ts-ignore
        this.scartateList=data.scartateList;
        // @ts-ignore
        this.ricevuteList=data.ricevuteList;
        // @ts-ignore
        this.bozzeList=data.bozzeList;
        // @ts-ignore
        this.elencoClientiScartate=data.elencoClientiScartate;
        // @ts-ignore
        this.elencoClientiBozze=data.elencoClientiBozze;
        // @ts-ignore
        this.refreshTime=data.refreshTime;
        this.isLoadingUser=false;
      }
    }

  }

  //in minuti
  getPassedTime(refresh : Date | any){
    var now=new Date();
    var old=new Date(refresh);
    let diff=Math.abs(now.getTime() - old.getTime());
    return (diff/1000)/60;
  }

  async refreshData(){
    let diff=this.getPassedTime(this.refreshTime);
    if(diff < 10){      
      this.toastService.openToastWithConfig(true, 5000, "Potrai aggiornare i dati tra circa "+(10-Math.floor(diff))+" minuti", "warning");
      return;
    }
    this.isLoadingUser=true;
    this.callStack();
  }

  async refreshScartate(){
    this.updateScartate = true;
    await this.getFattureScartate(this.userInfo!.user_id);
    this.updateLocalStorageData();
    this.updateScartate = false;
  }

  async refreshBozze(){
    this.updateBozze = true;
    await this.getBozzeFatture();
    this.updateLocalStorageData();
    this.updateBozze = false;
  }

  async refreshRicevute(){
    this.updateRicevute = true;
    await this.getFattureRicevute();
    this.updateLocalStorageData();
    this.updateRicevute = false;
  }

  async refreshScartateClienti(){
    await this.getClientiFattureScartate();
    this.updateLocalStorageData();
  }

  async refreshBozzeClienti(){
    await this.getClientiFattureBozze();
    this.updateLocalStorageData();
  }

  async callStack(){
    await this.getBozzeFatture();
    await this.getFattureRicevute();
    await this.getFattureScartate(this.userInfo!.user_id);
    await this.getClientiFattureScartate();  
    await this.getClientiFattureBozze();  
    this.refreshTime=new Date();
    this.updateLocalStorageData();
  }



  updateLocalStorageData(){
    var tmp={"refreshTime":this.refreshTime,"scartateList":this.scartateList,"ricevuteList":this.ricevuteList,
             "bozzeList":this.bozzeList,"elencoClientiScartate":this.elencoClientiScartate,"elencoClientiBozze":this.elencoClientiBozze};
        localStorage.setItem("dashboardData_"+this.userInfo!.user_id,JSON.stringify(tmp));
        this.isLoadingUser=false;
  }


  async getBozzeFatture() {
    this.params = this.params.append('searchFilter', '{"workflow_state_code":["Bozza"]}');
    let response = await this.fatturaAttivaService.findInvoice(this.userInfo!.user_id, this.params);
    if (response.success) {
      this.bozze = true;
      this.numeroBozze = response.data.totalRows;
      this.bozzeList=[];
      this.putInList(this.bozzeList,response);
    } else {
      this.toastService.openToastWithConfig(true, 5000, response.data.msg, "error")
    } 
  }


  putInList(lista : FattureList[] ,response : GenericResponse){
    try{
        let data=response.data.data;
        for(var i=0;i < data.length; i++){
          if(this.isInvisibileInDashboard(data[i].tags))
                continue;
          let tmp :FattureList={denominazione:'',
                                invoice_data:'',
                                invoice_n:'',
                                amount:'',
                                workflow_state:'',
                                error:'',
                                relateds:[]
                              };
          tmp.workflow_state=data[i].workflow_state;
          tmp.amount = data[i].Importo;
          tmp.denominazione=data[i].Denominazione;
          tmp.invoice_n=data[i]['Numero fattura'];
          tmp.invoice_data=data[i]['Data fattura'];
          try{
            tmp.relateds=data[i].relateds;
          }catch(error){
          }
          lista.push(tmp);
        }
    }catch(error){
      return;
    }
  }


  isInvisibileInDashboard(tags : {text : string}[]){
    for (var i=0; i < tags.length; i++)
      if (tags[i].text.includes('VISIBILE_DASHBOARD:')) {
        return true;
      }  
    return false;
  }

  async getFattureRicevute() {
    let dataAttuale = new Date();
    let dataScorsa = new Date();
    dataScorsa.setDate(dataAttuale.getDate() - 5);

    this.params = this.params.append('searchFilter', '{"date_created":{"0":"' + dataScorsa.toISOString() + '", "1": "' + dataAttuale.toISOString() + '"}}');

    let response = await this.invoiceService.findPassiveInvoice(this.userInfo!.user_id, this.params);
    if (response.success) {
      this.ricevute = true;
      this.ricevuteList=[];
      if (response.data.totalRows > 0) {
        (response.data.data).forEach((fattura: any) => {
          this.ricevuteList.push({denominazione:fattura.Denominazione,
            invoice_data:fattura.DataFattura,
            invoice_n:fattura.NumeroFattura,
            amount:fattura.Importo,
            workflow_state:'',
            error:'',
            relateds:[]
          });
        });
      } 
    } else {
      this.toastService.openToastWithConfig(true, 5000, response.data.msg, "error")
    } 

  }

  async getFattureScartate(user_id: string) {
    let dataAttuale = new Date();
    let dataScorsa = new Date();
    dataScorsa.setDate(dataAttuale.getDate() - 15);
    this.params = this.params.delete('searchFilter');
    // this.params = this.params.append('searchFilter', '{"workflow_state_code":"s2sc", "date_created":{"0":"' + dataScorsa.toISOString() + '", "1": "' + dataAttuale.toISOString() + '"}}');
    this.params = this.params.append('searchFilter', '{"workflow_state_code":["Scartata", "Rifiutata"], "date_created":{"0":"' + dataScorsa.toISOString() + '", "1": "' + dataAttuale.toISOString() + '"}}');
   
    let response = await this.fatturaAttivaService.findInvoice(user_id, this.params);
    if (response.success) {
      if (user_id !== this.userInfo!.user_id) {
        // il rivenditore ha fatto richiesta
        return response;
      } else {
        this.scartate = true;
        this.numeroScartate = response.data.totalRows;
        this.scartateList=[];
        this.putInList(this.scartateList,response);
        return undefined;
      }
    } else {
      this.toastService.openToastWithConfig(true, 5000, response.data.msg, "error");
      return undefined;
    } 
  }

  async getFattureBozze(user_id: string) {
    /*let dataAttuale = new Date();
    let dataScorsa = new Date();
    dataScorsa.setDate(dataAttuale.getDate() - 15);*/
    this.params = this.params.delete('searchFilter');
    // this.params = this.params.append('searchFilter', '{"workflow_state_code":"s2sc", "date_created":{"0":"' + dataScorsa.toISOString() + '", "1": "' + dataAttuale.toISOString() + '"}}');
    this.params = this.params.append('searchFilter', '{"workflow_state_code":["Bozza"]}');
   
    let response = await this.fatturaAttivaService.findInvoice(user_id, this.params);
    if (response.success) {
      if (user_id !== this.userInfo!.user_id) {
        // il rivenditore ha fatto richiesta
        return response;
      } else {
        this.bozze = true;
        this.numeroBozze = response.data.totalRows;
        this.bozzeList=[];
        this.putInList(this.bozzeList,response);
        return undefined;
      }
    } else {
      this.toastService.openToastWithConfig(true, 5000, response.data.msg, "error");
      return undefined;
    } 
  }
  
  async getClientiFattureScartate() {    
    if (this.userInfo!.role == "R") {
      let paramsUser = this.params;
      paramsUser = paramsUser.delete('sortKey');
      paramsUser = paramsUser.append('sortKey', 'username');
      paramsUser = paramsUser.delete('pageSize');
      paramsUser = paramsUser.append('pageSize', 256);
      paramsUser = paramsUser.delete('searchFilter');
      paramsUser = paramsUser.append('searchFilter', '{"id_utente_reseller":"' + this.userInfo!.user_id + '"}');
      let managedUsersTable = await (await this.userService.getManagedUsersTable(this.userInfo!.user_id, paramsUser!)).data;
      if (managedUsersTable.totalRows > 0) {
        this.elencoClientiScartate=[];
        for await(const utente of managedUsersTable.data){
          await this.getFattureScartate(utente.user_id).then(
            (response: GenericResponse | undefined) => {
              let value = response!.data.totalRows;
              if (value > 0) {
                let oggetto: any = {};
                oggetto['username'] = utente.username;
                oggetto['scartate'] = value;
                oggetto['u'] = utente;              
                this.elencoClientiScartate!.push(oggetto);
              }
            });
        }
      }
    }
  }

  async getClientiFattureBozze() {    
    if (this.userInfo!.role == "R") {
      let paramsUser = this.params;
      paramsUser = paramsUser.delete('sortKey');
      paramsUser = paramsUser.append('sortKey', 'username');
      paramsUser = paramsUser.delete('pageSize');
      paramsUser = paramsUser.append('pageSize', 256);
      paramsUser = paramsUser.delete('searchFilter');
      paramsUser = paramsUser.append('searchFilter', '{"id_utente_reseller":"' + this.userInfo!.user_id + '"}');
      let managedUsersTable = await (await this.userService.getManagedUsersTable(this.userInfo!.user_id, paramsUser!)).data;
      if (managedUsersTable.totalRows > 0) {
        this.elencoClientiBozze=[];
        for await(const utente of managedUsersTable.data){
          await this.getFattureBozze(utente.user_id).then(
            (response: GenericResponse | undefined) => {
              let value = response!.data.totalRows;
              if (value > 0) {
                let oggetto: any = {};
                oggetto['username'] = utente.username;
                oggetto['bozze'] = value;
                oggetto['u'] = utente;              
                this.elencoClientiBozze!.push(oggetto);
              }
            });
        }
      }
    }
  }

  setSessionUser(u : UserInfo) {
    this.loginService.setSessionUserInfo(u);
  }

  async getErrorDescription(index : number){
        if(this.scartateList[index].error!="")
            return;
        var error_msg="";
        if(this.scartateList[index].relateds.length>0){
          let response = await (await this.invoiceService.getNotifications(this.scartateList[index].relateds!, this.userInfo!.user_id)).data;
          response.forEach((result:any)=>{
              try{
                error_msg += result.errori+'\n\n';
              }catch(error){}
          });
          if(error_msg!=""){
            this.scartateList[index].error=error_msg;
            this.updateLocalStorageData();
          }
      }     
  }

  formattaAmount(amount: any){
    try{
        return Number(amount).toFixed(2);
    }catch(e){
        return amount;
    }
  }


   /* async getFattureInviate() {
    this.params = this.params.append('searchFilter', '{"workflow_state_code":"s2"}');

    let response = await this.invoiceService.findInvoice(this.userInfo!.user_id, this.params);
    
    if (response.success) {
      this.inviate = true;
      this.numeroInviate = response.data.totalRows;
      this.putInList(this.inviateList,response);
    } else {
      this.toastService.openToastWithConfig(true, 5000, response.data.msg, "error")
    } 
  }*/


}